import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe } from '@angular/common';

@Pipe({
  name: 'appCurrency',
  standalone: true,
})
export class CurrencyPipeWithCustomFormat implements PipeTransform {
  transform(value: never, digits?: string): string | null {
    const currencyPipe = new CurrencyPipe('en-US');
    digits ||= '1.2-2';
    return currencyPipe.transform(value, digits);
  }
}
